export default {"src":"/_next/static/media/0xb33eaad8d922b1083446dc23f610c2567fb5180f.f2b8cf86.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};